import { styled } from '@mui/material/styles';

export const OcrWordRoot = styled('div', { label: 'OcrWordRoot' })(({ theme }) => ({
  position: 'absolute',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: 2,
  cursor: 'move',
  boxSizing: 'content-box',
  pointerEvents: 'all',
  userSelect: 'none',
  opacity: 0,
  transition: '0.2s opacity',
  willChange: 'opacity',

  '&:hover': {
    opacity: 1,
  },
}));
